export { StyledHeadlineTextSection as HeadlineSection } from './styles';
export { StyledSubHeadlineSection as SubHeadlineSection } from './styles';
export { StyledHeadlineText as Headline } from './styles';
export { StyledHeadlineTextSection } from './styles';
export { StyledHeadlineTextSectionLeft } from './styles';
export { StyledHeadlineTextSectionBright } from './styles';
export { StyledSubHeadlineSection } from './styles';
export { StyledSubHeadlineSectionBright } from './styles';
